<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 20 20"
        :fill="color"
        fill-rule="evenodd"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <path
            d="M0 0V15.1463H6.17885V20H20V10.2025L14.3639 5.05831V0L0 0ZM2.18229 2.94627H12.2575V1.60693H2.18229V2.94627ZM7.6108 15.1463V6.37476H13.3615V11.1082H18.5681V18.6778H7.6108V15.1463ZM14.7934 7.31058L17.5055 9.78608H14.792V7.31058H14.7934Z"
        ></path>
    </svg>
</template>

<script>
export default {
    name: 'CopySVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
